/**
 * Whether the BeSTT closure an interruption or a cancellation set off left a
 * document of the contract open (JBWEB-1089). The mission has changed whatever
 * BeSTT answered; what is left has been reported, to be closed by hand.
 */
export const isContractClosureIncomplete = (closure) =>
  closure?.failed?.length > 0 || closure?.reason === 'unexpected_error';

export const CONTRACT_CLOSURE_INCOMPLETE =
  "mais son contrat n'a pas pu être entièrement clôturé sur BeSTT : il faudra le faire à la main.";
